/**
 * Shared timer resume helper for Step1/Step2.
 * Returns sessionId + stable timerId so Timer can persist startedAt inside the session payload.
 */
import { useAppSelector } from 'store/hooks'
import { getSessionId } from 'store/slices/test'

interface TimerResumeResult {
  sessionId: string | null
  timerId: string
}

const useTimerResume = (timerId: string): TimerResumeResult => {
  const sessionId = useAppSelector(getSessionId)

  return { sessionId, timerId }
}

export default useTimerResume
